import request from "@/utils/request";

// 获取表格数据列表
export function getTableLists(data) {
  return request({
    url: '/admin/game_cheating_script',
    method: "get",
    params: data
  });
}

// 开挂管理-新增
export function addNewAccount(data) {
  return request({
    url: '/admin/game_cheating_script',
    method: "post",
    data
  });
}

// 开挂管理-获取账号详情
export function getAccountDetail(data) {
  return request({
    url: `/admin/game_cheating_script/${data.id}`,
    method: "get"
  });
}

// 开挂管理-编辑修改
export function editAccount(data) {
  return request({
    url: `/admin/game_cheating_script/${data.id}`,
    method: "put",
    data
  });
}

// 开挂管理-删除
export function deleteAccount(data) {
  return request({
    url: `/admin/game_cheating_script/${data.id}`,
    method: "delete"
  });
}

// 获取运营后台游戏列表
export function getGamsLists() {
  return request({
    url: '/admin/get_yun_game_tree',
    method: "get"
  });
}
